<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe
-->
<template>
  <div class="container">
    <a-spin :spinning="loading">
      <PlateTitle
        title="订单信息"
        :subtitle="'（业务流水号：' + orderNo + '）'"
      />
      <div class="table_list">
        <a-table
          bordered
          :pagination="false"
          :columns="columns"
          :data-source="data"
        >
          <a slot="name" slot-scope="text">{{ text }}</a>
        </a-table>

        <a-table
          class="red-table"
          bordered
          :pagination="false"
          :columns="columns1"
          :data-source="data"
        >
          <template slot="name" slot-scope="text">
            <a-input v-model="name" placeholder="请输入支付人姓名" />
          </template>
          <template slot="card" slot-scope="text">
            <a-input v-model="card" placeholder="请输入身份证号码" />
          </template>
          <template slot="code" slot-scope="text">
            <a-input v-model="code" placeholder="请输入支付账号" />
          </template>
        </a-table>
      </div>
      <PlateTitle title="选择支付方式" />
      <!-- <a-spin :spinning="loading">
      <div class="code">
        <a-radio-group
          :default-value="value"
          @change="handleChange"
          button-style="solid"
        >
          <a-radio-button value="a"> 聚合支付 </a-radio-button>
          <a-radio-button value="b"> 网银支付 </a-radio-button>
        </a-radio-group>
        <div class="code_img">
          
          <template v-if="curStr != 'b' && curStr != ''">
            <button @click="hanldeClick" class="btn_list">点击，去支付</button>
          </template>
        </div>

      </div>
    </a-spin> -->

      <div class="pay_info">
        <div class="info_box">
          <div class="head_s">聚合支付</div>
          <div class="logo">
            <img
              @click="hanldeClick('a')"
              src="../../assets/image/jh.jpg"
              alt=""
            />
          </div>
        </div>
        <div class="info_box">
          <div class="head_s">网银支付</div>
          <div class="logo">
            <form :action="url" method="post" name="form1" ref="form">
              <div v-show="false">
                <input type="text" name="message" v-model="formJson.message" />
                <input
                  type="text"
                  name="signature"
                  v-model="formJson.signature"
                />
                <input type="text" name="txCode" v-model="formJson.txCode" />
                <input type="text" name="txName" v-model="formJson.txName" />
                <input type="text" name="Flag" v-model="formJson.Flag" />
                <input type="text" name="isDgEnv" v-model="formJson.isDgEnv" />
                <input
                  type="text"
                  name="digitalEnvelope"
                  v-model="formJson.digitalEnvelope"
                />
                <input
                  type="text"
                  name="signAlgorithm"
                  v-model="formJson.signAlgorithm"
                />
                <input type="text" name="signSN" v-model="formJson.signSN" />
                <input
                  type="text"
                  name="encryptSN"
                  v-model="formJson.encryptSN"
                />
                <input
                  type="text"
                  name="institutionID"
                  v-model="formJson.institutionID"
                />
              </div>
              <button
                v-if="name && card && code"
                @click="hanldeClick('b')"
                class="btn_list"
                type="submit"
              ></button>
              <div v-else class="btn_list" @click="hanldeClick('b')"></div>
            </form>
          </div>
        </div>
      </div>

      <div class="footer">
        <a-button class="btn" type="primary" @click="goTo">
          我已支付，下一步
        </a-button>
      </div>
      <div></div>
    </a-spin>
  </div>
</template>
<script>
import PlateTitle from "@/components/PlateTitle";
import {
  getInformation,
  getInformations,
  completeBasic,
  getZjInfo,
  getZjCode,
} from "@/api/insure.js";
const columns = [
  {
    title: "产品名称",
    dataIndex: "guaranteeTypeStr",
    key: "guaranteeTypeStr",
    width: 300,
  },
  {
    title: "购买人",
    dataIndex: "name",
    key: "name",
    width: 400,
  },
  {
    title: "应付金额（元）",
    dataIndex: "sumPremium",
    key: "sumPremium",
    scopedSlots: { customRender: "sumPremium" },
  },
];
const columns1 = [
  {
    title: "*支付人姓名",
    dataIndex: "name",
    key: "name",
    width: 300,
    scopedSlots: { customRender: "name" },
  },
  {
    title: "*身份证号码",
    dataIndex: "guaranteeTypeStr",
    key: "guaranteeTypeStr",
    width: 400,
    scopedSlots: { customRender: "card" },
  },
  {
    title: "*支付账号",
    dataIndex: "guaranteeTypeStr",
    key: "guaranteeTypeStr",
    scopedSlots: { customRender: "code" },
  },
];

const data = [];
export default {
  components: { PlateTitle },
  data() {
    return {
      data,
      columns,
      columns1,
      orderNo: "",
      infoJson: {},
      encrypted: "",
      value: "",
      url: "",
      url1: "",
      curStr: "",
      formJson: {},
      urls: "",
      loading: false,
      name: "",
      card: "",
      code: "",
      id: "",
    };
  },
  mounted() {
    this.getInformation();
    this.orderNo = this.getQueryString("orderNo");
  },
  methods: {
    handleChange(e) {},
    goTo() {
      this.$router.push({ path: "/insure", query: { orderNo: this.orderNo } });
    },
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getInformation() {
      this.loading = true;
      this.data = [];
      let orderNo = this.getQueryString("orderNo");
      getInformation({ orderNo: orderNo }).then(({ data: data }) => {
        this.infoJson = data;
        this.id = data.id;
        this.name = data.basicAccountName;
        this.card = data.basicAccountIdCode;
        this.code = data.basicAccountNo;
        this.data.push(data);
      });
      // 来源接口
      getInformations({ orderNo: orderNo }).then(({ data: data }) => {
        this.encrypted = data.encrypted;

        // 聚合
        getZjCode(this.encrypted).then(({ data: data }) => {
          this.urls = data.data.imageUrl;

          // 跳转网银支付的信息
          getZjInfo(this.encrypted).then(({ data: data }) => {
            this.formJson = data.data || {};
            this.url = data.data?.action;
            this.loading = false;
          });
        });
      });
    },
    hanldeClick(val) {
      if (!this.name) {
        this.$message.error("请输入支付人姓名");
        return;
      }
      if (!this.card) {
        this.$message.error("请输入身份证号码");
        return;
      }

      if (!this.checkCard(this.card)) {
        this.$message.error("请输入合法的身份证号码");
        return;
      }

      if (!this.code) {
        this.$message.error("请输入支付账号");
        return;
      }

      this.postBasic();
      if (val == "b") {
        return;
      }

      if (val == "a") {
        // window.open(this.urls, "_blank");
        location.href = this.urls;
      } else {
        location.href = `${this.urls}/${this.encrypted}`;

        // window.open(, "_blank");
      }
    },
    postBasic() {
      completeBasic({
        basicAccountName: this.name,
        basicAccountNo: this.code,
        basicAccountIdCode: this.card,
        id: this.id,
      }).then((res) => {});
    },
    checkCard(idNumber) {
      // 先校验身份证号码的长度和格式是否正确
      if (idNumber.length !== 18) {
        return false;
      }
      var regExp = /^[1-9]\d{16}(\d|X|x)$/;
      if (!regExp.test(idNumber)) {
        return false;
      }

      // 根据身份证号码前17位计算校验位
      var nums = idNumber.split("");
      var factors = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      var sum = 0;
      for (var i = 0; i < 17; i++) {
        sum += nums[i] * factors[i];
      }
      var checkCode = "10X98765432"[sum % 11];

      // 将校验位与身份证号码的最后一位比较
      return checkCode === idNumber[17];
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  min-height: 726px;
  margin-top: 30px;
  position: relative;
  padding: 50px 30px;

  .table_list {
    margin: 30px;
  }

  .code {
    width: 100%;

    .code_img {
      width: 230px;
      height: 170px;
      // background: red;
      margin: auto;
      margin-top: 100px;
      margin-bottom: 10px;
    }

    p {
      text-align: center;
    }
  }

  .footer {
    border-top: 2px solid #d7d7d7;
    width: 100%;
    text-align: right;
    margin-top: 40px;
    padding-top: 30px;
  }
  .btn_list {
    width: 148px;
    height: 148px;
    color: white;
    border: none;
    cursor: pointer;
    background: url("../../assets/image/wy.png") no-repeat;
    background-position: center;
    background-size: cover;
  }
}
.pay_info {
  display: flex;
  .info_box {
    width: 380px;
    height: 400px;
    background: #ffffff;
    box-shadow: 5px 15px 30px 5px rgba(75, 111, 158, 0.15);
    border-radius: 5px 5px 5px 5px;
    margin-right: 20px;
    .head_s {
      padding-top: 40px;
      text-align: center;
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #333333;
    }
    .logo {
      margin: auto;
      width: 150px;
      height: 150px;
      margin-top: 33px;
      border: 1px solid #d5d6d6;
      img {
        width: 148px;
        height: 148px;
        cursor: pointer;
      }
    }
  }
}
.red-table {
  /deep/ .ant-table-column-title {
    color: red !important;
  }
}
</style>
